import React from 'react';
import Sidebar from "../pages/Sidebar";
import Navbar from "../pages/Navbar";

const Home = () => {
    return (
        <div className="container-fluid p-0">
            <div className="row m-0 nav-row">
                <Navbar/>
            </div>
            <div className="row m-0 form-body">
                <div className="col-2 p-0" style={{width: "12.5vw"}}>
                    <Sidebar/>
                </div>
                <div className="col-2 p-0" style={{width: "87.5vw", display: "none"}}></div>
            </div>
        </div>);
};

export default Home;
